import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import SignInForm from '../../components/signInForm/SignInForm'
import cartTomatoes from '../../assets/cart-tomatoes.webp'


const SignInPage = () => {
  return (
    <div className='page-wrapper bg-light'>
      <Container fluid>
        <Row>
          <Col sm={12} md={6}>
            <Image src={cartTomatoes} style={{objectFit:"cover"}} className="w-100 h-100" />
          </Col>
          <Col sm={12} md={6}>
            <SignInForm />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default SignInPage